import React from 'react'
import { useProject } from '../../../../model/hooks/useProject'
import { ProjectLoadingSkeleton } from '../../layout/ProjectLoadingSkeleton'
import { ProjectLayout } from '../../layout/ProjectLayout'
import { TechnicalReportFormsList } from './TechnicalReportFormsList'
import { SectionHeading } from '../../../../components/SectionHeading'
import { GenerateReportAction } from './GenerateReportAction'
import { useGetTechnicalFormsList } from '../../../../model/api/project/useGetTechnicalFormsList'
import {
  getProjectFormTypeSectionsForCategory,
  ProjectFormCategoryEnum,
  TechnicalFormStatusEnum,
  getAccompanyingReportRoute,
} from 'shared'
import { useNavigate } from 'react-router-dom'
import { RoutesEnum } from '../../../../model/enums/RoutesEnum'
import { AlertTriangleIcon } from 'lucide-react'
import { ActionPanel } from '../../../../components/ActionPanel'

interface Props {
  projectFormCategory: ProjectFormCategoryEnum
}

export const TechnicalReportForm: React.FC<Props> = (props) => {
  const navigate = useNavigate()
  const { project, id: projectId } = useProject()
  const { data: listData } = useGetTechnicalFormsList(projectId, props.projectFormCategory)

  if (!project || !listData) {
    return <ProjectLoadingSkeleton />
  }

  const accompanyingReportNotFinished = !!listData?.data?.list?.a?.find(
    (form) => form.status === TechnicalFormStatusEnum.EDIT,
  )

  return (
    <ProjectLayout project={project}>
      <SectionHeading
        title="B) Souhrnná technická zpráva"
        buttons={
          accompanyingReportNotFinished ? (
            <></>
          ) : (
            <>
              <GenerateReportAction
                projectId={project.id}
                projectFormType={getProjectFormTypeSectionsForCategory(props.projectFormCategory).b}
              />
            </>
          )
        }
      />
      {accompanyingReportNotFinished && (
        <div className="my-3">
          <ActionPanel
            title={
              <div className="flex items-center gap-3">
                <AlertTriangleIcon className="text-orange-400" size={24} /> Průvodní list není
                dokončen
              </div>
            }
            description="Před vyplněním Souhrnné zprávy je potřeba dokončit Průvodní list."
            buttonText="Přejít na průvodní list"
            onClick={() => {
              const accompanyingReportRoute = getAccompanyingReportRoute(props.projectFormCategory)
              navigate(`${RoutesEnum.PROJECTS}/${projectId}/${accompanyingReportRoute}`)
            }}
          />
        </div>
      )}
      <TechnicalReportFormsList
        disabledLinks={accompanyingReportNotFinished}
        projectId={project.id}
        projectFormCategory={props.projectFormCategory}
      />
    </ProjectLayout>
  )
}
